import React from "react";
import "./ImageAccordion.css";

function ImageAccordion() {
    return (
        <div className="accordian-container">
            <div className="img-accordion">
                <div className="img img1">
                    <p>Custom Pools</p>
                    <h3>
                        Tailored to fit your specific requirements and
                        landscape, our custom pools are the epitome of
                        personalized luxury.
                    </h3>
                </div>
                <div className="img img2">
                    <p>Infinity Pools</p>
                    <h3>
                        Offering seamless views and a touch of elegance, our
                        infinity pools are designed to blend beautifully with
                        your surroundings.
                    </h3>
                </div>
                <div className="img img3">
                    <p>Family Pools</p>
                    <h3>
                        Designed with safety and fun in mind, our family pools
                        provide the perfect setting for unforgettable memories.
                    </h3>
                </div>
                <div className="img img4">
                    <p>Spa Pools</p>
                    <h3>
                        Combining relaxation and therapeutic benefits, our spa
                        pools offer a private retreat within your backyard.
                    </h3>
                </div>
            </div>
        </div>
    );
}

export default ImageAccordion;
